<section class="resumo-pedido" aria-label="Resumo do pedido">
  <h2><i class="fa fa-bar-chart" aria-hidden="true"></i> Resumo do pedido</h2>
  <dl>
    <div><dt><i class="fa fa-cubes" aria-hidden="true"></i>Itens</dt><dd>{{ produtosAdicionadosLength }}</dd></div>
    @if (exibirPontuacao) { <div><dt><i class="fa fa-star" aria-hidden="true"></i>Pontuação</dt><dd>{{ valorTotalPontuacaoProdutosAdicionados | number: '1.2-2' }}</dd></div> }
    <div class="total"><dt><i class="fa fa-money" aria-hidden="true"></i>Total{{ exibirFatorFinanceiro ? ' parcial' : '' }}</dt><dd>{{ valorParcialProdutosAdicionados | currency: 'BRL' }}</dd></div>
  </dl>
</section>
